import {Link, Navigate, useParams} from "react-router-dom";
import BillingInvoiceTab from "./BillingInvoiceTab";
import BillingPaymentTab from "./BillingPaymentTab";
import MonthlyUsageSummaryTab from "./MonthlyUsageSummaryTab";
import MonthlyActiveItemsTab from "./MonthlyActiveItemsTab";
import PaymentMethodTab from "./PaymentMethodTab";

const TABS = [
    {slug: 'overview', label: 'Overview', icon: 'mdi-chart-box', Component: MonthlyUsageSummaryTab},
    {slug: 'monthly-active-items', label: 'Monthly Active Items', icon: 'mdi-format-list-bulleted', Component: MonthlyActiveItemsTab},
    {slug: 'billing-invoice', label: 'Billing Invoice', icon: 'mdi-office-building', Component: BillingInvoiceTab},
    {slug: 'billing-payment', label: 'Billing Payment', icon: 'mdi-cash-multiple', Component: BillingPaymentTab},
    {slug: 'payment-method', label: 'Payment Method', icon: 'mdi-credit-card-outline', Component: PaymentMethodTab},
];

function BillingPage() {
    const {tab} = useParams();
    const active = TABS.find((t) => t.slug === tab);
    if (!active) {
        return <Navigate to={`/billing/${TABS[0].slug}`} replace />;
    }
    const ActiveComponent = active.Component;

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card-box">
                        <ul className="nav nav-tabs nav-bordered">
                            {TABS.map((t) => (
                                <li className="nav-item" key={t.slug}>
                                    <Link to={`/billing/${t.slug}`}
                                          className={`nav-link ${active.slug === t.slug ? 'active' : ''}`}>
                                        <span className="d-inline-block d-sm-none"><i className={`mdi ${t.icon}`}/></span>
                                        <span className="d-none d-sm-inline-block">{t.label}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <div className="tab-content">
                            <ActiveComponent />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BillingPage;
